import Certificate from "../../assests/img/certificate.png";
import "./VerifyCertificate.scss";
import Info from "./Info";
import React, { useState, useEffect } from "react";
import Group from "../../assests/img/Group.png";
import Header from "../../components/Header/Header";
import Label from "../../components/Label/Label";
import TextField from "../../components/TextField/TextField";
import HookForm from "../../components/HookForm/HookForm";
import Calendar from "../../components/Calendar/Calendar";
import CustomButton from "../../components/CustomButton/CustomButton";
import Footer from "../../components/Footer/Footer";
import { getVerifyCertificateAction } from "../../reduxThings/slices/DigipankSlices";
import { useDispatch, useSelector } from "react-redux";
import { verifyCertificate } from "../../services/certificateApi";
import {
  getCertificateVerifyErrorMessage,
  isValidCertificateId,
} from "../../util/certificateHelpers";
import Seo from "../../components/Seo/Seo";
import { PAGE_SEO } from "../../config/seoConfig";

const CertificateForm = {
  certificate: {
    name: "certificate",
    validate: {
      required: {
        value: true,
        message: "Certificate ID (UUID) is required",
      },
    },
  },
};

const VerifyCertificate = () => {
  const [certificate, setCertificate] = useState(null);
  const [birthDate, setBirthDate] = useState(null);
  const [isVerified, setIsVerified] = useState(false);
  const [isVerifying, setIsVerifying] = useState(false);

  const dispatch = useDispatch();
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });
  const [carousalStatus, setCarousalStatus] = useState(true);

  const handleClick = (data) => {
    setCarousalStatus(data);
  };

  React.useEffect(() => {
    window.scrollTo(0, 0);
    function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }

    window.addEventListener("resize", handleResize);

    return (_) => {
      window.removeEventListener("resize", handleResize);
    };
  });

  const appData = useSelector(
    (e) => e?.DigipankSlice?.verifyCertificateState?.verifyCertificateStateData
  );

  useEffect(() => {
    dispatch(getVerifyCertificateAction());
  }, [dispatch]);

  const onFormSubmit = async (data) => {
    const certificateId = data?.certificate?.trim();

    if (!certificateId) {
      window.alert("Please enter your certificate ID.");
      return;
    }

    if (!birthDate) {
      window.alert("Please select your date of birth.");
      return;
    }

    if (!isValidCertificateId(certificateId)) {
      window.alert(
        "Invalid certificate ID. Enter the full certificate UUID provided with your certificate.",
      );
      return;
    }

    setIsVerifying(true);

    try {
      const verifiedCertificate = await verifyCertificate(
        certificateId,
        birthDate,
      );

      setCertificate(verifiedCertificate);
      setIsVerified(true);
      window.alert("Certificate verified successfully!");
    } catch (error) {
      setCertificate(null);
      setIsVerified(false);
      window.alert(
        error?.response
          ? getCertificateVerifyErrorMessage(
              error,
              appData?.certificateNotFound ||
                "No certificate found for the provided certificate ID and date of birth.",
            )
          : error?.message ||
              "Unable to verify certificate. Check the certificate ID and date of birth.",
      );
    } finally {
      setIsVerifying(false);
    }
  };

  const handleDownload = () => {
    if (!isVerified || !certificate) {
      window.alert("Please verify your certificate before downloading.");
      return;
    }

    const imageUrl = Certificate;
    const link = document.createElement("a");
    link.href = imageUrl;
    link.download = `${certificate.firstName || "certificate"}-${
      certificate.lastName || "download"
    }.png`;
    link.click();
  };

  return appData?.title === "Verify certificate" ? (
    <div className="downloadCertificate">
      <Seo {...PAGE_SEO.verifyCertificate} />
      <div className="verifyContainer">
        <div className="verifyContainer_inner">
          <Header handleClick={handleClick} />
          <div
            className="centerDiv"
            style={{ height: dimensions.height + "px" }}
          >
            <div className="certificateContainer">
              <Label className="verifyTitle" title={appData?.title} />
              <Label className="verifyPara" title={appData?.subTitle} />
              <div className="form">
                <HookForm defaultForm={{}} onSubmit={onFormSubmit}>
                  {(formMethod) => {
                    return (
                      <div className="form1">
                        <TextField
                          formMethod={formMethod}
                          rules={CertificateForm.certificate.validate}
                          name={CertificateForm.certificate.name}
                          errors={formMethod?.errors}
                          autoFocus={true}
                          type="text"
                          placeholder={
                            appData.certificateIdPlaceholder ||
                            appData.certificateNumberPlaceholder
                          }
                        />
                        <Calendar
                          birthdatePlaceHolder={appData.birthdatePlaceHolder}
                          selected={birthDate}
                          onChange={setBirthDate}
                        />
                        <div className="verify_Btn">
                          <CustomButton
                            type="submit"
                            title={
                              isVerifying
                                ? "Verifying..."
                                : appData.verifyBtn
                            }
                          />
                        </div>
                      </div>
                    );
                  }}
                </HookForm>
              </div>
            </div>
          </div>
        </div>
        <div className="certificateBox">
          <div className="congrats">
            <div className="congratsText">{appData?.congrats}</div>
            <img src={Group} alt="Certificate verification success" width="100%" />
          </div>
          {isVerified && certificate ? (
            <Info
              name={` ${certificate.firstName || ""}  ${
                certificate.lastName || ""
              }`}
              program={appData.program}
              startDate={certificate.startDate}
              endDate={certificate.endDate}
              icon={Certificate}
            />
          ) : (
            <div className="certificate_Preview_Placeholder">
              <Label
                title="Verify your certificate to preview it here."
                className="verifyPara"
              />
            </div>
          )}
          <div className="downloadButton">
            <CustomButton
              title={appData?.downloadBtn}
              onClick={handleDownload}
            />
          </div>
        </div>
        <Footer />
      </div>
    </div>
  ) : (
    <div className="loader-div">
      <div className="loader">
        <lottie-player
          autoplay
          loop
          src="https://lottie.host/7d0ba31f-e11f-47ed-8248-b1a8f5389ad8/oMZAHSKOuQ.json"
        ></lottie-player>
      </div>
    </div>
  );
};
export default VerifyCertificate;
